var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInPersonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_371_1241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6249 32.0136C36.2031 33.4069 35.2254 33.8524 33.9258 33.8485C28.3212 33.8339 22.7166 33.8427 17.112 33.8417C14.6969 33.8417 13.783 32.6132 14.3907 30.124C15.189 26.8559 17.0454 24.4564 19.9934 23.1606C23.5195 21.6104 27.1427 21.5792 30.6883 23.0972C33.7944 24.4271 35.724 26.9046 36.4806 30.3698C36.5158 30.5287 36.5759 30.6817 36.624 30.8377C36.6249 31.2297 36.6249 31.6216 36.6249 32.0136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.764597 30.669C1.2308 28.8174 1.9338 27.0946 3.18347 25.6623C5.15742 23.4003 7.67435 22.359 10.5113 22.1143C12.3928 21.9525 14.2751 22.0207 16.1964 22.6876C13.0634 25.6818 11.243 29.1792 12.2901 33.8406C9.9295 33.8406 7.52635 33.8406 5.12227 33.8406C4.56542 33.8406 4.00765 33.8299 3.4508 33.8426C2.15857 33.8738 1.17622 33.4107 0.763672 32.0115C0.764597 31.565 0.764597 31.1175 0.764597 30.669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3844 19.6229C21.5364 19.5878 18.6773 16.4571 18.7272 12.3338C18.7725 8.55566 21.8842 5.42396 25.5269 5.48929C29.1834 5.55559 32.1499 8.76626 32.1425 12.6497C32.136 16.5039 29.0798 19.656 25.3844 19.6229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8266 19.6233C7.69085 19.5999 5.2063 16.9605 5.24608 13.6953C5.28493 10.4661 7.80463 7.8472 10.8618 7.85598C13.9679 7.86573 16.4358 10.5168 16.4155 13.821C16.396 17.0824 13.9263 19.6467 10.8266 19.6233Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_371_1241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 39,
    fill: "white",
    transform: "translate(0.220703 0.140625)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInPersonIcon);
export default __webpack_public_path__ + "static/media/in-person-icon.dde86f30ce0d8070a941aaa273c93a95.svg";
export { ForwardRef as ReactComponent };